export const BLUEPRINT_META_ADS_MARKDOWN = `
# Blueprint Meta Ads - Hướng dẫn chạy quảng cáo chuẩn FIT Tour

Tài liệu này quy định các tiêu chuẩn, quy trình và chiến lược chạy Meta Ads (Facebook/Instagram Ads) dành cho team Marketing tại FIT Tour. Tất cả nhân sự tham gia vận hành quảng cáo bắt buộc phải tuân thủ để tối ưu ngân sách, đảm bảo luồng data về CRM và tránh rủi ro khóa tài khoản.

---

## 1. Mục Tiêu & KPI (CPL)

Mục tiêu chính của Meta Ads tại FIT Tour là thu thập khách hàng tiềm năng (Lead Generation) và đổ trực tiếp về hệ thống CRM. 
Hiệu quả chiến dịch được đo lường chính qua **Cost Per Lead (CPL)**.

| Khối Thị Trường (BU) | Ngân sách Tháng | Mục tiêu CPL (Trần) | Mục tiêu CPA (Khách chốt) |
| :--- | :--- | :--- | :--- |
| **BU1 (Trung Quốc, Đài Loan)** | 40.000.000đ | *Theo dõi trên ERP* | *Theo dõi trên ERP* |
| **BU2 (Âu, Úc, Mỹ, Nhật, Hàn...)** | 50.000.000đ | *Theo dõi trên ERP* | *Theo dõi trên ERP* |
| **BU3 (MICE / Sự Kiện)** | 0đ | - | - |
| **BU4 (Tây Tạng, Bhutan, Ladakh...)** | 30.000.000đ | *Theo dõi trên ERP* | *Theo dõi trên ERP* |

> 💡 **Tip:** Nếu CPL vượt mốc trên trong 3 ngày liên tiếp, cần TẮT (kill) ads ngay lập tức và thay đổi content/target.

---

## 2. Quy Tắc Đặt Tên (Naming Convention)

Để hệ thống CRM tracking đúng nguồn và chiến dịch, việc đặt tên là **BẮT BUỘC**.

* **Campaign:** \`[BU] Objective | Product | Period | Ghi chú\`
* **Ad Set:** \`[BU] Tour | Loại chạy | Creative | Budget | Ghi chú\`
* **Ads:** \`[BU] Tên Creative | Format | Hook | Version\`

👉 [Xem chi tiết SOP Đặt tên Ads tại đây](/tai-lieu/sop-meta-ads).

---

## 3. Chân Dung Khách Hàng (Targeting & Audiences)

Cập nhật thêm sau

---

## 4. Quy Chuẩn Nội Dung (Creative/Copywriting)

Mỗi Campaign nên có tối thiểu 02 Quảng cáo, bao gồm ít nhất 01 Video và 01 Hình ảnh, để Meta có nhiều lựa chọn tối ưu phân phối.

---

## 5. Từ Khóa Cấm Kỵ (Policy & Compliance)

> [!WARNING]
> Tuyệt đối **KHÔNG** sử dụng các từ ngữ sau trong bài quảng cáo (kể cả trên text, hình ảnh hay audio video) để tránh bị Meta khóa tài khoản hoặc hạn chế Fanpage.

* **Cam kết tuyệt đối:** "Chắc chắn đậu visa 100%", "Bao đậu visa", "Giá rẻ nhất thị trường".
* **Phân biệt đối xử/Cá nhân hóa:** "Bạn có đang béo phì?", "Dành riêng cho người độc thân", "Người theo đạo Hồi".
* **Việc làm/Kiếm tiền:** "Việc nhẹ lương cao", "Kiếm tiền dễ dàng khi đi du lịch".
* **Đặc tính cơ thể:** "Đen", "Mập", "Lùn", "Yếu".
* Các từ lách luật lộ liễu: "V.1.s.a", "V!sa". Meta AI hiện tại rất thông minh và sẽ đánh dấu tài khoản lách luật.

---

## 6. Quy Tắc Tối Ưu (Scaling & Killing)

Cập nhật thêm sau

`;
